/* Pagina NÜMO: comparsa allo scorrimento, audio del video, «Acquista ora» che scende all'offerta */
(function () {
  if (window.thkNumoPronto) return;
  window.thkNumoPronto = true;

  var pocoMovimento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function rivela() {
    var elementi = document.querySelectorAll('.thk-numo [data-numo-rivela]');
    if (!('IntersectionObserver' in window)) {
      elementi.forEach(function (el) { el.classList.add('is-visibile'); });
      return;
    }
    var osservatore = new IntersectionObserver(function (voci) {
      voci.forEach(function (voce) {
        if (voce.isIntersecting || voce.boundingClientRect.top < 0) {
          voce.target.classList.add('is-visibile');
          osservatore.unobserve(voce.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    elementi.forEach(function (el) { osservatore.observe(el); });
  }

  function audio() {
    document.querySelectorAll('[data-numo-audio]').forEach(function (bottone) {
      var cornice = bottone.closest('.thk-numo-video__cornice');
      var video = cornice && cornice.querySelector('video');
      if (!video) { bottone.hidden = true; return; }
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (voci) {
          voci.forEach(function (voce) {
            if (voce.isIntersecting && video.paused) {
              var avvio = video.play();
              if (avvio && avvio.catch) avvio.catch(function () {});
            }
          });
        }, { threshold: 0.25 }).observe(video);
      }
      bottone.addEventListener('click', function () {
        video.muted = !video.muted;
        if (!video.muted) { video.volume = 1; video.play(); }
        bottone.setAttribute('aria-pressed', String(!video.muted));
        bottone.setAttribute('aria-label', video.muted ? "Attiva l'audio" : "Disattiva l'audio");
      });
    });
  }

  function scendi() {
    document.querySelectorAll('a[data-numo-scendi]').forEach(function (link) {
      link.addEventListener('click', function (evento) {
        var meta = document.querySelector(link.getAttribute('href'));
        if (!meta) return;
        evento.preventDefault();
        meta.scrollIntoView({ behavior: pocoMovimento ? 'auto' : 'smooth', block: 'start' });
      });
    });
  }

  function avvia() { rivela(); audio(); scendi(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', avvia);
  else avvia();
})();
